module.exports = __webpack_public_path__ + "img/m-home-03.1a12c313.webp";